import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  buttonType,
  variant,
} from './../../../_models/components-types.interface';

@Component({
  selector: 'shared-button-lovers',
  templateUrl: './button-lovers.component.html',
  styleUrls: ['./button-lovers.component.scss'],
})
export class ButtonLoversComponent implements OnInit {
  @Input() public idButton: string = '';
  @Input() public width: number;
  @Input() public height: number;
  @Input() public label: string = '';
  @Input() public iconEsquerdo: string = '';
  @Input() public iconDireito: string = '';
  @Input() public iconEsquerdoImagem: string = '';
  @Input() public iconDireitoImagem: string = '';
  @Input() public loading: boolean = false;
  @Input() public darkMode: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public variant: variant = 'primary';
  @Input() public type: buttonType = 'button';

  @Output() public onClick: EventEmitter<null> = new EventEmitter();

  // Control Variables
  public hasIconEsquerdo: boolean = false;
  public hasIconDireito: boolean = false;
  public hasIconEsquerdoImagem: boolean = false;
  public hasIconDireitoImagem: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.hasIconEsquerdo = this.iconEsquerdo !== '';
    this.hasIconEsquerdoImagem = this.iconEsquerdoImagem !== '';

    this.hasIconDireito = this.iconDireito !== '';
    this.hasIconDireitoImagem = this.iconDireitoImagem !== '';
  }

  public gerarIcone(): string {
    let icon = 'fa ';

    if (this.loading) {
      icon += 'fa-spinner fa-spin';
      return icon;
    }

    icon += this.iconEsquerdo;

    return icon;
  }

  public gerarIconeDireito(): string {
    let icon = 'fa ';

    if (this.loading) {
      icon += 'fa-spinner fa-spin';
      return icon;
    }

    icon += this.iconDireito;

    return icon;
  }

  public gerarIconeDeImagemEsquerdo(): string {
    let icon = 'assets/images/icons/';

    icon += this.iconEsquerdoImagem;

    return icon;
  }

  public gerarIconeDeImagemDireito(): string {
    let icon = 'assets/images/icons/';

    icon += this.iconDireitoImagem;

    return icon;
  }

  public handleClick(event: Event): void {
    this.onClick.emit();
  }
}
